module.exports = __webpack_public_path__ + "static/media/neg-z.3ed96d13.jpg";